'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { SaleSearch, SaleStatus } from '@qogita/canary-client'
import { Icon, type IconName } from '@qogita/ui/v2/icon'
import { ReactNode } from 'react'

import { SearchResult } from './search-result'

/** Canary sale statuses have more variations than we want to show in the UI */
const saleStatusRemapping = {
  CLOSED: 'COMPLETED',
  COMPLETED: 'COMPLETED',
  PAID: 'COMPLETED',
  NOTIFIED: 'CURRENT',
  OPEN: 'CURRENT',
  DECLINED: 'EXPIRED',
  EXPIRED: 'EXPIRED',
} as const satisfies Record<SaleStatus, string>

/**
 * Displays a list of the sales search results grouped by status
 */
export function SaleSearchResults({ sales }: { sales: SaleSearch[] }) {
  const salesByStatus = Object.groupBy(
    sales,
    (sale) => saleStatusRemapping[sale.status],
  )

  return (
    <>
      <SalesResultsSubsection
        sales={salesByStatus.CURRENT}
        heading="Active Orders"
        icon="heroicons/outline/bell-alert"
      />
      <SalesResultsSubsection
        sales={salesByStatus.COMPLETED}
        heading="Fulfilled Orders"
        icon="heroicons/outline/clipboard-document-list"
      />
      <SalesResultsSubsection
        sales={salesByStatus.EXPIRED}
        heading="Expired/Declined Orders"
        icon="heroicons/outline/archive-box"
      />
    </>
  )
}

/** A list of sales with a heading */
function SalesResultsSubsection({
  sales = [],
  heading,
  icon,
}: {
  sales?: SaleSearch[]
  heading: ReactNode
  icon: IconName
}) {
  if (sales.length === 0) {
    return null
  }

  return (
    <>
      <h2 className="flex items-center gap-3 px-3 py-2 text-gray-700">
        <Icon name={icon} className="size-4" /> {heading}
      </h2>
      {sales.map((sale) => (
        <SearchResult
          key={sale.qid}
          href={`/orders/${sale.qid}/`}
          displayValue={sale.orderFid}
        />
      ))}
    </>
  )
}
